/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";
  
    getDealerwareWebComponentsModule()
          .constant(
          'gridMapVehiclesNotUnderContract', {
              'stock_number'        : [ 'stock_number', 'stock_number_display' ],
              'license'             : [ 'license', 'license_display' ],
              'fuel_level'          : [ 'fuel_level', 'fuel_level_display' ],
              'current_state'       : [ 'current_state', 'current_state_display' ],
              'last_accessed_at'    : [ 'last_accessed_at', 'last_accessed_at_display' ],
              'confirmation_token'  : [ 'confirmation_token', 'confirmation_token_display' ],
              'last_off_lot'        : [ 'last_off_lot', 'last_off_lot_display' ],
              }
      );
  
    export class VehiclesNotUnderContractController {
        public static $inject: string[] = [
            'gridMapVehiclesNotUnderContract',
            'DealerwareVehicleCollection',
            'DataUtils',
            '$mobilityCompanyAuthentication',
            '$state',
            '$timeout',
            '$filter',
            '$parse',
            '$dealerwareInternationalizationData',
            'i18nService',
        ];
  
        private _dataUtils          : any;
        private _gridColumns        : any;
  
        public collapsed            : boolean;
        public loading              : boolean = false;
        public error                : boolean = false;
        public gridMap              : any = { };
        public gridColumnDefs       : any;
        public locationHasGeolite : boolean = false;
        public offLotVehiclesCount  : number = 0;
        public offLotVehiclesText   : string;
  
        public vehicleCollection: any;
        public fullCollection: any;
  
        private gridSorts           : any = { };
        private defaultGridSorts    : any = {
            sort_by         : 'created',
            sort_direction  : 'desc'
        };
  
        public labels: {};
        public labelsUnformatted: {};
  
        constructor(
            public gridMapVehiclesNotUnderContract  : any,
            public DealerwareVehicleCollection      : any,
            public DataUtils                        : any,
            public $auth                            : any,
            public $state                           : any,
            public $timeout                         : any,
            public $filter                          : any,
            public $parse                           : any,
            public $dealerwareInternationalizationData: any,
            public i18nService                       : any
        ) {
  
            this.getLabels('dashboard');
  
            this._dataUtils = DataUtils.getInstance();
        }
  
        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                    _self.labels.columnHeaders = _self.$dealerwareInternationalizationData.formatLabelsByLanguage(localStorage.getItem('language'), _self.labels.columnHeaders);
                    _self.initColumns();
                },
                function(error: any) {
                    this.$dealerwareNotification.apiError(error);
                }
            );
        }
  
        private getCellClass = (_grid: any, row: any): string => {
            return this.locationHasGeolite && row.entity.off_lot ? 'red-off-lot' : '';
        }
  
        public toggleCollapsed() : void {
            this.collapsed = !this.collapsed;
        }
  
        public loadData() : void {
            var that = this;
            this.locationHasGeolite = this.$auth.location.settings.geolite;
  
            if (this.locationHasGeolite) {
                that._gridColumns.push({
                    name: 'Last Off Lot',
                    field: 'last_off_lot_display',
                    visible: true,
                    renderHtml: true,
                    cellClass: this.getCellClass,
                    formatCallback: function(date: any) {
                        let columnText = '';
                        if (this.off_lot) {
                            columnText =  that.labels.messages.now;
                        } else {
                            columnText = date ? moment(date).fromNow() : 'N/A';
                        }
                        return `<a href="${that.$state.href('root.private.application.vehicles.details', { vehicleId: this.id })}">${columnText}</a>`
                    },
                    sortingAlgorithm: function (a: any, b: any, rowA: any, rowB: any) {
                        if (rowA.entity.off_lot) return -1;
  
                        const valueA = rowA.entity.last_off_lot ? rowA.entity.last_off_lot : -1;
                        const valueB = rowB.entity.last_off_lot ? rowB.entity.last_off_lot : -1;
                        if (new Date(valueA) > new Date(valueB)) return -1;
                        if (new Date(valueA) < new Date(valueB)) return 1;
                        return 0;
                    }
                });
            }
  
            // Set grid parameters.
            //
            this.loading = true;
            this.gridMap = this.gridMapVehiclesNotUnderContract;
            this.gridColumnDefs = this._gridColumns;
            this.DealerwareVehicleCollection.vehicles_not_under_contract({
                promise: true,
                params: {location_id: this.$auth.location.id}
            })
            .then((vehicleCollection: any) => {
                that.vehicleCollection = vehicleCollection;
                // persist a copy of the full collection, before/if we filter it to only show off lot cars
                that.fullCollection = angular.copy(that.vehicleCollection);
                that.offLotVehiclesCount = vehicleCollection.data.filter((elem: any) => {
                    return elem.data.off_lot
                }).length;
                that.offLotVehiclesText = that.offLotVehiclesTextGenerator();
            })
            .catch(() => {
                that.error = true;
            })
            .finally(() => {
                that.loading = false;
            });
        }
  
        public initColumns(): void {
            const that = this;
  
            this._gridColumns = [
                {
                    name: 'Stock #',
                    displayName: that.labels.columnHeaders.stock_number,
                    field: 'stock_number_display',
                    visible: true,
                    renderHtml: true,
                    cellClass: this.getCellClass,
                    formatCallback  : function (value : any) {
  
                        return that._dataUtils.isBlank(value) || value === 'NULL' ? '' :
                            `<a href=${that.$state.href('root.private.application.vehicles.details',
                            { vehicleId: this.id })} class="dashboard-vehicles-no-contract-stock"> ${this.stock_number} </a>`
                    },
                    sortingAlgorithm: function (a: any, b: any, rowA: any, rowB: any) {
  
                        var valueA = that._dataUtils.isBlank(rowA.entity.stock_number) ? '' :
                            rowA.entity.stock_number.toLowerCase();
                        var valueB = that._dataUtils.isBlank(rowB.entity.stock_number) ? '' :
                            rowB.entity.stock_number.toLowerCase();
  
                        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
                    }
                },
                {
                    name: 'License Plate',
                    displayName: that.labels.columnHeaders.license_plate,
                    field: 'license_display',
                    visible: true,
                    renderHtml: true,
                    cellClass: this.getCellClass,
                    formatCallback  : function (value : any) {
  
                        return that._dataUtils.isBlank(value) ? '' :
                            `<a href=${that.$state.href('root.private.application.vehicles.details',
                            { vehicleId: this.id })} class="dashboard-vehicles-no-contract-license"> ${value} </a>`
                    },
                    sortingAlgorithm: function (a: any, b: any, rowA: any, rowB: any) {
  
                        var valueA = that._dataUtils.isBlank(rowA.entity.license) ? '' :
                            rowA.entity.license.toLowerCase();
                        var valueB = that._dataUtils.isBlank(rowB.entity.license) ? '' :
                            rowB.entity.license.toLowerCase();
  
                        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
                    }
                },
                {
                    name: 'Vehicle Model',
                    displayName: that.labels.columnHeaders.vehicle_model,
                    field: 'model',
                    visible: true,
                    cellClass: this.getCellClass
                },
                {
                    name: 'Model Year',
                    displayName: that.labels.columnHeaders.model_year,
                    field: 'model_year',
                    visible: true,
                    cellClass: this.getCellClass
                },
                {
                    name: 'Status',
                    displayName: that.labels.columnHeaders.status,
                    field: 'current_state_display',
                    visible: true,
                    renderHtml: true,
                    cellClass: this.getCellClass,
                    formatCallback  : function (value : any) {
                        return that._dataUtils.isBlank(value) ? '' :
                            `<a href=${that.$state.href('root.private.application.vehicles.details',
                            { vehicleId: this.id })} class="dashboard-vehicles-no-contract-status">${that.$filter('titlecase')(that.$filter('underscoreless')(that.getStateLabelDict(value)))}</a>`
                    },
                    sortingAlgorithm: function (a: any, b: any, rowA: any, rowB: any) {
  
                        var valueA = that._dataUtils.isBlank(rowA.entity.current_state) ? '' :
                            rowA.entity.current_state.toLowerCase();
                        var valueB = that._dataUtils.isBlank(rowB.entity.current_state) ? '' :
                            rowB.entity.current_state.toLowerCase();
  
                        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
                    }
                },
                {
                    name: 'Fuel Level',
                    displayName: that.labels.columnHeaders.fuel_level,
                    field: 'fuel_level_display',
                    visible: true,
                    cellClass: this.getCellClass,
                    exporterFieldCallback: function ( value: any ) {
                        return ` ${value}`;
                    },
                    formatCallback: function (value : any) {
                        if (!value) return;
                        const [first, last] = value.split('/');
                        const calc = Number(first) / Number(last);
                        return calc >= 1 ? 'Full' :
                          new RegExp('^0/').test(value) ? 'Empty' : value;
                    },
                    sortingAlgorithm: function (a: any, b: any, rowA: any, rowB: any) {
                      var valueA = that._dataUtils.isBlank(rowA.entity.fuel_level ) ? 0 :
                            that.$parse(rowA.entity.fuel_level)();
                      var valueB = that._dataUtils.isBlank(rowB.entity.fuel_level ) ? 0 :
                            that.$parse(rowB.entity.fuel_level)();
  
                      return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
                    }
                },
                {
                    name            : 'Last Contract',
                    displayName: that.labels.columnHeaders.last_contract,
                    field           : 'confirmation_token_display',
                    visible         : true,
                    renderHtml      : true,
                    cellClass: this.getCellClass,
                    formatCallback  : function (value : any) {
  
                        return that._dataUtils.isBlank(value) ? '' :
                            `<a href=${that.$state.href('root.private.application.contracts.details',
                            { contractId: this.reservation_id })} class="dashboard-vehicles-no-contract-last">${this.confirmation_token}</a>`
                    },
                    sortingAlgorithm: function (a: any, b: any, rowA: any, rowB: any) {
  
                        var valueA = that._dataUtils.isBlank(rowA.entity.confirmation_token) ? '' :
                            rowA.entity.confirmation_token.toLowerCase();
                        var valueB = that._dataUtils.isBlank(rowB.entity.confirmation_token) ? '' :
                            rowB.entity.confirmation_token.toLowerCase();
  
                        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
                    }
                },
                {
                    name: 'Days Off Contract',
                    displayName: that.labels.columnHeaders.days_off_contract,
                    field: 'last_dropoff',
                    visible: true,
                    cellClass: this.getCellClass,
                    formatCallback: function(date: any) {
                        return date ? Math.round(moment().diff(moment(date), 'days', true)) : ' ';
                    },
                    sortingAlgorithm: function (a: any, b: any, rowA: any, rowB: any) {
                        var valueA = rowA.entity.last_dropoff || '9';
                        var valueB = rowB.entity.last_dropoff || '9';
                        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
                    }
                },
                {
                    name: 'Last Modified By',
                    displayName: that.labels.columnHeaders.last_modified_by,
                    field: 'last_accessed_by',
                    visible: false,
                    cellClass: this.getCellClass
                }
            ];

            this.$timeout(() => { this.loadData(); });
        }
  
        private offLotVehiclesTextGenerator = () : string => {
            const plural = (this.offLotVehiclesCount == 1) ? '' : 's';
            return `${this.offLotVehiclesCount} ${this.labels.fleetStatus.vehicle}${plural} ${this.labels.fleetStatus.currently_off_lot}`;
  
        }
  
        public toggleOffLotVehicleFilter = () : void => {
            const offLotVehicles = this.vehicleCollection.data.filter((vehicle: any) => vehicle.data.off_lot);
            this.vehicleCollection.data = this.vehicleCollection.data.length === offLotVehicles.length ? this.fullCollection.data: offLotVehicles;
        }
  
        private getStateLabelDict(state: string) {
            return this.labels.fleetStatus[state];
        }
    }
  
    getDealerwareWebComponentsModule().controller('VehiclesNotUnderContractController', VehiclesNotUnderContractController);
  
    export class VehiclesNotUnderContractDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'VehiclesNotUnderContractController';
        public controllerAs     : string    =   'vehiclesNotUnderContractController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/dashboard_widgets/vehicles_not_under_contract/vehicles_not_under_contract_directive.html';
        public static $inject   : string[]  =   [];
  
        constructor() {}
  
        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }
  
    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareVehiclesNotUnderContract",() => new VehiclesNotUnderContractDirective());

}